var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registration-layout"},[_c('header',{staticClass:"registration-content-container"},[_c('Logo',{attrs:{"href":_vm.globalUrls.selfcare}})],1),_vm._t("default"),_c('Notification'),_c('Loader')],2)}
var staticRenderFns = []

export { render, staticRenderFns }